
export default {
  computed: {
    year():number {
      return new Date().getFullYear()
    }
  }
};
